<div id="filters">
    <app-building-selection (buildingChange)="buildingDidChange($event)"></app-building-selection>

  <section class="job-filters">
    <h4>
      {{ Localization.Unassigned | translate }}
      <ng-container *ngIf="count">
        ({{count}})
      </ng-container>
    </h4>
    <a class="sort-direction">
      <i class="fa fa-caret-up fa-lg"
         (click)="sortAscending()"
         [class.active]="filters.sortDirection === SortDirection.ASC"></i>
      <i class="fa fa-caret-down fa-lg"
         (click)="sortDescending()"
         [class.active]="filters.sortDirection === SortDirection.DESC"></i>
    </a>
    <i (click)="openFiltersModal()"
       [mdbTooltip]="Localization.Filter | translate" class="fa fa-lg fa-filter" placement="bottom"></i>
    <i (click)="toggleMenu()"
       [class.disabled]="!enableMenu"
       class="fa fa-lg fa-ellipsis-v">
      <div [matMenuTriggerFor]="jobActions.menu"></div>
    </i>
  </section>
</div>
<app-action-contextual-menu #jobActions
                            [teams]="teams"
                            [plural]="count > 1"
                            (delete)="delete.emit()"
                            (assign)="assign.emit($event)"></app-action-contextual-menu>

